/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

export const getAddOnID = addOn => (addOn && addOn.id ? addOn.id : null);
export const getAddOnName = addOn => (addOn && addOn.name ? addOn.name : null);
export const getAddOnUnitPrice = addOn =>
  addOn && addOn.unit_price ? addOn.unit_price : null;
export const getAddOnQuantity = addOn =>
  addOn && addOn.quantity ? addOn.quantity : 0;
export const getAddOnPriceText = addOn =>
  addOn && addOn.price_text ? addOn.price_text : null;

// queue -> addon
export const getQueueAddOnID = queue => (queue && queue.id ? queue.id : null);
export const getQueueAddOnTitle = queue =>
  queue && queue.title ? queue.title : null;
export const getQueueAddOnDescription = queue =>
  queue && queue.description ? queue.description : null;
export const getQueueAddOnQuantity = queue =>
  queue && queue.quantity ? queue.quantity : 0;



// WEBPACK FOOTER //
// ./src/selectors/addOn.js